import * as React from 'react';
import { getStoreState, storeDispatch } from 'state/Store';
import * as Actions from '../state/actions';
import styled from 'styled-components';
import { isPro, makeFontNameCustom, selectLocalFiles } from 'utils';
import { trackEvent } from 'utils/Tracker';
import FileType from 'data/FileType';
import SmallButton from '../controller/components/SmallButton';
import { BetaLabel } from './components/BetaLabel';

const Wrapper = styled.div`
  text-align: left;
`;

const Subtitle = styled.div`
  opacity: 0.7;
  font-size: 14px;
  line-height: 20px;
`;

const FontsList = styled.ul`
  margin-top: 16px;
  margin-bottom: -8px;
  padding-left: 16px;

  li {
    display: flex;
    align-items: center;
    margin: 8px 0;
  }
`;

const DeleteButton = styled(SmallButton)`
  background-color: rgba(var(--controller-fg-rgb), 1);
  mask: url(/media/icons/icon-delete-color.svg) no-repeat 50% 50%;
`;

export const CustomFontsRow: React.FC = () => {
  // const [isLoadingScript, _setIsLoadingScript] = React.useState(false);
  const user = getStoreState().app.user;

  const showUpgradeModal = React.useCallback(() => {
    trackEvent('Clicked Upgrade', { location: 'Custom fonts settings' });
    storeDispatch(Actions.showBuyingOptions());
  }, []);

  const uploadFont = React.useCallback(async () => {
    const files = await selectLocalFiles(FileType.Font, false);
    if (files.length) {
      const file = files[0];
      const fontName = '';
      /*
      // https://github.com/Pomax/lib-font/issues/131
      if (window.Font === undefined) {
        setIsLoadingScript(true);
        await loadScript('/js/lib-font.browser.js');
        setIsLoadingScript(false);
      }
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        // Create a font object
        const font: any = new Font(newUUID());
        // Pass the buffer, and the original filename
        font.fromDataBuffer(reader.result, file.name);

        font.onload = (evt: any) => {
          // Map the details LibFont gathered from the font to the
          // "font" variable
          const f = evt.detail.font;
          // From all the OpenType tables in the font, take the "name"
          // table so we can inspect it further
          const { name } = f.opentype.tables;
          // From the name table, take the entry with ID "1". This is
          // the Font Family name. More info and names you can grab:
          // https://docs.microsoft.com/en-us/typography/opentype/spec/name
          const fontName: string = name.get(1);
          const OS2 = font.opentype.tables['OS/2'];
          const fontWeight: number = OS2.usWeightClass;
          console.log('Upload font', fontName, fontWeight);
        };
      };*/
      storeDispatch(Actions.showUploadFont(file, fontName));
    }
  }, []);

  const deleteFont = React.useCallback(async (fontName: string) => {
    storeDispatch(Actions.deleteCustomFont(fontName));
  }, []);

  const pro = isPro(user);
  const customFonts = user?.customFonts ?? [];

  return (
    <Wrapper>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>Custom fonts</div>
        <BetaLabel />
      </div>
      <Subtitle>
        Use your brand fonts. Only .ttf and .otf files accepted.{' '}
        {!pro && (
          <>
            Only available to Pro users -{' '}
            <a onClick={showUpgradeModal}>Upgrade</a>
          </>
        )}
      </Subtitle>
      {pro && (
        <FontsList>
          {customFonts.length > 0 &&
            customFonts.map((font, index) => (
              <li key={font.name}>
                <span style={{ fontFamily: makeFontNameCustom(font.name) }}>
                  {font.name}
                </span>
                <DeleteButton onClick={() => deleteFont(font.name)} />
              </li>
            ))}
        </FontsList>
      )}
      {pro && (
        <button
          className="medium primary"
          onClick={uploadFont}
          // disabled={isLoadingScript}
          style={{ marginTop: 16 }}
        >
          Upload font
        </button>
      )}
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/account/CustomFontsRow.tsx